import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Menubar from "./components/Menubar";
import Footer from "./components/Footer";

const Layout = () => {
    useEffect(() => {
        document.body.classList.add('bg-gray-100');
    }, [])
    
  return (
    <>
      <Sidebar />
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Menubar />
        <div className="container-fluid py-2">
          <div className="row mt-2">
            <Outlet />
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Layout;
